import api from './api';
import {
  AnalyticsDashboardData,
  UsageAnalytics,
  HiringPerformanceAnalytics,
  PeriodComparison,
  AnalyticsPeriod,
} from '@/types';

export interface AnalyticsQueryParams {
  period?: AnalyticsPeriod;
  startDate?: string;
  endDate?: string;
  groupBy?: 'day' | 'week' | 'month';
}

export interface ComparisonQueryParams {
  currentPeriodStart: string;
  currentPeriodEnd: string;
  previousPeriodStart: string;
  previousPeriodEnd: string;
}

export interface ExportQueryParams {
  type: 'usage' | 'hiring-performance';
  startDate?: string;
  endDate?: string;
}

const analyticsService = {
  async getDashboardOverview(params?: AnalyticsQueryParams): Promise<AnalyticsDashboardData> {
    const response = await api.get('/analytics/overview', { params });
    return response.data.data;
  },

  async getUsage(params?: AnalyticsQueryParams): Promise<UsageAnalytics> {
    const response = await api.get('/analytics/usage', { params });
    return response.data.data;
  },

  async getHiringPerformance(params?: AnalyticsQueryParams): Promise<HiringPerformanceAnalytics> {
    const response = await api.get('/analytics/hiring-performance', { params });
    return response.data.data;
  },

  async getUsageComparison(params: ComparisonQueryParams): Promise<PeriodComparison> {
    const response = await api.get('/analytics/usage-comparison', { params });
    return response.data.data;
  },

  async exportData(params: ExportQueryParams): Promise<Blob> {
    const response = await api.get('/analytics/export', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  async downloadExport(params: ExportQueryParams, filename?: string): Promise<void> {
    const blob = await this.exportData(params);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    const defaultFilename = `${params.type}-${new Date().toISOString().split('T')[0]}.csv`;
    link.download = filename || defaultFilename;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};

export default analyticsService;
